module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M32 2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2zm-8 15c0 .552-.432 1-.984 1H16v3.064c0 .932-.374 1.214-1.174.632l-6.248-4.644c-.8-.58-.728-1.526.072-2.108l6.14-4.644c.804-.582 1.21-.296 1.21.636V14h7.016c.552 0 .984.448.984 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-square-3.js
// module id = 1226
// module chunks = 14